import api from '../../utils/apiFetch';

const path = 'organizations';

export default {
  getOrgPayouts: () => api.get(`${path}/payouts`),
};
